import React from 'react';
import { FolderPlusSVG } from '../../@common_components/svgs/folder-plus.svg';

export const FolderPlusIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return <FolderPlusSVG {...props} />;
};

export default FolderPlusIcon;
